module.exports = __webpack_public_path__ + "img/028adcb0-46ea-4aa3-9eb3-820993ebb278_base_resized.6e1449d1.jpg";